import { render, staticRenderFns } from "./TablaSerie.vue?vue&type=template&id=c097cbe4&"
import script from "./TablaSerie.vue?vue&type=script&lang=ts&"
export * from "./TablaSerie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c097cbe4', component.options)
    } else {
      api.reload('c097cbe4', component.options)
    }
    module.hot.accept("./TablaSerie.vue?vue&type=template&id=c097cbe4&", function () {
      api.rerender('c097cbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/TablaSerie.vue"
export default component.exports